import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  commonAlertMessages: {

  },
  loaderPage: {
    msg: 'Wait, authentication is in progress.',
  }
};

const commonStaticContentSlice = createSlice({
  name: "commonStaticContentSlice",
  initialState,
  reducers: {
    saveCommonStaticContent: (state, action) => {
    },
  }
})

export const { saveCommonStaticContent } = commonStaticContentSlice.actions;

export default commonStaticContentSlice.reducer;
